import { gql } from '@apollo/client';
import { INVOICE_FIELDS } from '../../fragments';
import {
  ApproveInvoiceProps,
  CancelInvoiceProps,
  CreateInvoiceProps,
  RejectInvoiceProps,
  SubmitInvoiceProps,
  UpdateInvoiceProps,
} from './invoice.types';
import { InvoiceType } from '../../../types';
import { GET_INVOICES, GET_INVOICES_BY_DEPARTMENT_ID, GET_INVOICE_BY_INVOICE_ID } from '../../queries';

export const CREATE_INVOICE = gql`
  ${INVOICE_FIELDS}
  mutation createInvoice(
  $ownerId: ID!
  $departmentId: ID!
  $clientId: ID
  $billingId: ID
  $name: String
  $email: String
  $invoiceDueDate: String
  ) {
    createInvoice(
    ownerId: $ownerId
    departmentId: $departmentId
    clientId: $clientId
    billingId: $billingId
    name: $name
    email: $email
    invoiceDueDate: $invoiceDueDate
    ) {
      ...InvoiceFields
    }
  }
`;

export function createInvoice({
  client,
  ownerId,
  departmentId,
  clientId,
  billingId,
  name,
  email,
  invoiceDueDate,
}: CreateInvoiceProps) {
  return client?.mutate<{ createInvoice: InvoiceType }>({
    mutation: CREATE_INVOICE,
    variables: {
      ownerId,
      departmentId,
      clientId,
      billingId,
      name,
      email,
      invoiceDueDate,
    },
    refetchQueries: [
      GET_INVOICES,
      GET_INVOICES_BY_DEPARTMENT_ID,
    ],
  });
}

export const CANCEL_INVOICE = gql`
  ${INVOICE_FIELDS}
  mutation cancelInvoice($invoiceId: ID!){
    cancelInvoice(invoiceId: $invoiceId){
      ...InvoiceFields
    }
  }
`;

export function cancelInvoice({
  client,
  invoiceId,
}: CancelInvoiceProps) {
  return client?.mutate<{ cancelInvoice: InvoiceType }>({
    mutation: CANCEL_INVOICE,
    variables: {
      invoiceId,
    },
    refetchQueries: [
      GET_INVOICES,
      GET_INVOICE_BY_INVOICE_ID,
      GET_INVOICES_BY_DEPARTMENT_ID,
    ],
  });
}

export const APPROVE_INVOICE = gql`
  ${INVOICE_FIELDS}
  mutation approveInvoice($invoiceId: ID!){
    approveInvoice(invoiceId: $invoiceId){
      ...InvoiceFields
    }
  }
`;

export function approveInvoice({
  client,
  invoiceId,
}: ApproveInvoiceProps) {
  return client?.mutate<{ cancelInvoice: InvoiceType }>({
    mutation: APPROVE_INVOICE,
    variables: {
      invoiceId,
    },
    refetchQueries: [
      GET_INVOICES,
      GET_INVOICES_BY_DEPARTMENT_ID,
      GET_INVOICE_BY_INVOICE_ID,
    ],
  });
}

export const REJECT_INVOICE = gql`
  ${INVOICE_FIELDS}
  mutation rejectInvoice($invoiceId: ID!){
    rejectInvoice(invoiceId: $invoiceId){
      ...InvoiceFields
    }
  }
`;

export function rejectInvoice({
  client,
  invoiceId,
}: RejectInvoiceProps) {
  return client?.mutate<{ rejectInvoice: InvoiceType }>({
    mutation: REJECT_INVOICE,
    variables: {
      invoiceId,
    },
    refetchQueries: [
      GET_INVOICES,
      GET_INVOICES_BY_DEPARTMENT_ID,
      GET_INVOICE_BY_INVOICE_ID,
    ],
  });
}

export const SUBMIT_INVOICE = gql`
  ${INVOICE_FIELDS}
  mutation submitInvoice($invoiceId: ID!){
    submitInvoice(invoiceId: $invoiceId){
      ...InvoiceFields
    }
  }
`;

export function submitInvoice({
  client,
  invoiceId,
}: SubmitInvoiceProps) {
  return client?.mutate<{ submitInvoice: InvoiceType }>({
    mutation: SUBMIT_INVOICE,
    variables: {
      invoiceId,
    },
    refetchQueries: [
      GET_INVOICES,
      GET_INVOICES_BY_DEPARTMENT_ID,
      GET_INVOICE_BY_INVOICE_ID,
    ],
  });
}

export const UPDATE_INVOICE = gql`
  ${INVOICE_FIELDS}
  mutation updateInvoice(
    $invoiceId: ID
    $departmentId: ID
    $ownerId: ID
    $clientId: ID
    $billingId: ID
    $invoiceDueDate: String
  ) {
    updateInvoice(
    invoiceId: $invoiceId
    ownerId: $ownerId
    departmentId: $departmentId
    clientId: $clientId
    billingId: $billingId
    invoiceDueDate: $invoiceDueDate
    ) {
      ...InvoiceFields
    }
  }
`;

export function updateInvoice({
  client,
  invoiceId,
  departmentId,
  ownerId,
  clientId,
  billingId,
  invoiceDueDate,
}: UpdateInvoiceProps) {
  return client?.mutate<{ updateInvoice: InvoiceType }>({
    mutation: UPDATE_INVOICE,
    variables: {
      invoiceId,
      departmentId,
      ownerId,
      clientId,
      billingId,
      invoiceDueDate,
    },
    refetchQueries: [
      GET_INVOICES,
      GET_INVOICES_BY_DEPARTMENT_ID,
      GET_INVOICE_BY_INVOICE_ID,
    ],
  });
}
